import React, { useState, useEffect } from "react";
import "./Sitereference.css";
import c24 from "../../assets/Site/Charge24.png";
import c24bg from "../../assets/6-Site-ref/Charge24.jpg";
// import c24card from "../../assets/6-Site ref./mini-card/Site1.png";
// import pea from "../../assets/Site/PEA.png";
// import peabg from "../../assets/6-Site ref./PEA.png";
// import peabgcard from "../../assets/6-Site-ref/mini-card/Site5.png";
// import TheMall from "../../assets/Site/the mall.png";
// import TheMallbg from "../../assets/6-Site ref./themall.png";
// import TheMallcard from "../../assets/6-Site ref./mini-card/Site4.png";
// import emsphere from "../../assets/Site/site-logo 1.png";
// import emspherebg from "../../assets/6-Site ref./Em.png";
// import emspherecard from "../../assets/6-Site ref./mini-card/Site2.png";
// import talaadThai from "../../assets/Site/Talaad.png";
// import talaadThaibg from "../../assets/6-Site ref./Talaad.png";
// import talaadThaicard from "../../assets/6-Site ref./mini-card/Site3.png";
    // import drainpumpbg from "../../assets/6-Site ref./Drainage.png";
    // import drainpumpcard from "../../assets/6-Site ref./mini-card/Site6.png";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
// import LinearProgress from "@mui/material/LinearProgress";
// import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { useTranslation } from "react-i18next";

const sites = [
  {
    id: 1,
    logo: c24,
    title: "main_head_site_c24",
    description:"main_dec_site_c24",
    background:
    c24bg,
    name: "Charge24",
    project: "EV Charger Staions",
    bullet1:"main_key_site_c241",
    bullet2:"main_key_site_c242",
  },
  // {
  //   id: 2,
  //   logo: pea,
  //   title: "main_head_site_pea",
  //   description:"main_dec_site_pea",
  //   background:
  //     peabg,
  //   name: "PEA",
  //   project: "EV charging",
  //   bullet1:"main_key_site_pea1",
  //   bullet2:"main_key_site_pea2",
  //   bullet3:"main_key_site_pea3",
  //   bullet4:"main_key_site_pea4",
  // },
  // {
  //   id: 3,
  //   logo: talaadThai,
  //   title: "main_head_site_talaadThai",
  //   description:"main_dec_site_talaadThai",
  //   background:
  //   talaadThaibg,
  //   name: "TalaadThai",
  //   project: "Billing Management System",
  //   bullet1:"main_key_site_talaadThai1",
  //   bullet2:"main_key_site_talaadThai2",
  //   bullet3:"main_key_site_talaadThai3",
  //   bullet4:"main_key_site_talaadThai4",
  // },
  // {
  //   id: 4,
  //   logo: TheMall,
  //   title: "XTEN พัฒนาระบบ ให้กับ The mall",
  //   description:
  //     "Jorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus.",
  //   background:
  //   TheMallbg,
  //   name: "The Mall",
  //   project: "Energy Management System",
  // },
  // {
  //   id: 5,
  //   logo: emsphere,
  //   title: "XTEN พัฒนาระบบ ให้กับ Emsphere",
  //   description:
  //     "Jorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus.",
  //   background:
  //   emspherebg,
  //   name: "Emsphere",
  //   project: "Retail Management System",  
  // },
  // {
  //   id: 6,
  //   logo: talaadThai,
  //   title: "XTEN พัฒนาระบบ ให้กับ TalaadThai",
  //   description:
  //     "Jorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus.",
  //   background:
  //     drainpumpbg,
  //   name: "Drain Pump",
  //   project: "Drainage Water Management",
  // },
];

// const initialCards = [
//   // {
//   //   id: 1,
//   //   background:
//   //   c24card,
//   //   name: "Charge24",
//   //   project: "EV Charging Stations",
//   // },
//   // {
//   //   id: 2,
//   //   background:
//   //   peabgcard,
//   //   name: "PEA",
//   //   project: "EV Charging",
//   // },
//   // {
//   //   id: 3,
//   //   background:
//   //   talaadThaicard,
//   //   name: "TalaadThai",
//   //   project: "Centralized Management System",
//   // },
//   // {
//   //   id: 4,
//   //   background:
//   //   TheMallcard,
//   //   name: "The Mall",
//   //   project: "Energy Management System",
//   // },
//   // {
//   //   id: 5,
//   //   background:
//   //   emspherecard,
//   //   name: "Emsphere",
//   //   project: "Retail Management System",
//   // },
//   // {
//   //   id: 6,
//   //   background:
//   //   drainpumpcard,
//   //   name: "Drain Pump",
//   //   project: "Drainage Water Management",
//   // },
// ];

function Sitereference() {
  // const [card, setCard] = useState(initialCards);
  const [currentSiteIndex] = useState(0);
  // const [progress, setProgress] = useState(0);
  // const [isIntervalRunning, setIsIntervalRunning] = useState(true);
  // const scrollContainerRef = useRef(null);
  const { t } = useTranslation();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // ฟังก์ชันตรวจสอบขนาดหน้าจอ
    const handleResize = () => {
      if (window.screen.width <= 932) {
        setIsMobile(true); // ถ้าเป็นมือถือหรือขนาดเล็ก
      } else {
        setIsMobile(false); // ถ้าเป็นขนาดใหญ่
      }
    };

    // เรียกใช้เมื่อแสดงผลครั้งแรกและเวลาเปลี่ยนขนาดหน้าจอ
    handleResize();
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   if (isIntervalRunning) {
  //     setProgress(0);
  //     const interval = setInterval(() => {
  //       setCurrentSiteIndex((prevIndex) => (prevIndex + 1) % sites.length); 
  //       setProgress(0); 
  //     }, 6000);

  //     return () => clearInterval(interval); 
  //   }
  // }, [isIntervalRunning]);

  // useEffect(() => {
  //   setProgress(0);
  //   const progressInterval = setInterval(() => {
  //     setProgress((prevProgress) => {
  //       if (prevProgress >= 6) {
  //         clearInterval(progressInterval); 
  //         return 6;
  //       }
  //       return prevProgress + 1; 
  //     });
  //   }, 1000);

  //   return () => clearInterval(progressInterval);
  // }, [currentSiteIndex]);

  // useEffect(() => {
  //   if (isIntervalRunning) {
  //     const updateCardInterval = setInterval(() => {
  //       const updatedCards = [...card]; 
  //       const firstItem = updatedCards.shift(); 
  //       updatedCards.push(firstItem); 
  //       setCard(updatedCards); 
  //     }, 6000); 
  //     return () => clearInterval(updateCardInterval);
  //   }
  // }, [card, isIntervalRunning]);

  // const handleNext = () => {
  //   setIsIntervalRunning(false);
  //   const updatedCards = [...card];
  //   const firstItem = updatedCards.shift(); 
  //   updatedCards.push(firstItem); 
  //   setCard(updatedCards);
  //   setCurrentSiteIndex((prevIndex) => (prevIndex + 1) % sites.length);
  //   setTimeout(() => {
  //     setProgress(0);
  //     setIsIntervalRunning(true);
  //   }, 100);
  // };

  // const handlePrevious = () => {
  //   setIsIntervalRunning(false);
  //   const updatedCards = [...card];
  //   const lastItem = updatedCards.pop(); 
  //   updatedCards.unshift(lastItem);
  //   setCard(updatedCards);
  //   setCurrentSiteIndex(
  //     (prevIndex) => (prevIndex - 1 + sites.length) % sites.length
  //   );
  //   setTimeout(() => {
  //     setProgress(0);
  //     setIsIntervalRunning(true);
  //   }, 100);
  // };

  const currentSite = sites[currentSiteIndex];

  useEffect(() => {
    // Create an IntersectionObserver to trigger the animation when in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // When element is in view, add visible class
            entry.target.classList.add("visible");
          } else {
            // When element is out of view, remove visible class (to trigger again)
            entry.target.classList.remove("visible");
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is in the viewport
      }
    );

    // Select all elements with the 'card-centraliz-content' class
    const elements = document.querySelectorAll(".card-centraliz-content");
    elements.forEach((element) => {
      observer.observe(element); // Observe each element
    });

    return () => {
      observer.disconnect(); // Clean up observer
    };
  }, []);

  return (
    <div className="site-content">
      <div className="text-site">
        <div className="text-header-site">Our Project Site Reference</div>
        <div className="sub-header-site">
          {t('main_head_site')}
        </div>
      </div>
      {!isMobile && (
      //   <div
      //   className="site-image"
      //   style={{
      //     backgroundImage: `url(${currentSite.background})`,
      //     backgroundColor: "rgba(0, 0, 0, 0.5)",
      //     backgroundSize: "cover",
      //     backgroundPosition: "center",
      //     backgroundBlendMode: "darken",
      //   }}
      // >
      //   <div className="site-details">
      //     <div className="charge24-logo">
      //       <img
      //         src={currentSite.logo}
      //         alt="site-logo"
      //         className="logo-image"
      //       />
      //     </div>
      //     <div className="charge24-text">
      //       <div className="text-site-head">{t(currentSite.title)}</div>
      //       <div className="sub-site-head">{t(currentSite.description)}</div>
      //       {currentSite.bullet1 && <li className="sub-site-head">{t(currentSite.bullet1)}</li>}
      //       {currentSite.bullet2 && <li className="sub-site-head">{t(currentSite.bullet2)}</li>}
      //       {currentSite.bullet3 && <li className="sub-site-head">{t(currentSite.bullet3)}</li>}
      //       {currentSite.bullet4 && <li className="sub-site-head">{t(currentSite.bullet4)}</li>}

      //     </div>
      //   </div>
      //   <div className="horizontal-scroll" ref={scrollContainerRef}>
      //     {card.map((site, index) => (
      //       <div className="site-card" key={index}>
      //         <div
      //           className="site-card-content"
      //           style={{ backgroundImage: `url(${site.background})` }}
      //         >
      //           <div className="title-card-bg">{site.name}</div>
      //           <div className="project-card-bg">{site.project}</div>
      //         </div>
      //       </div>
      //     ))}
      //   </div>
      //   <div className="navigation-container">
      //     <button
      //       onClick={handlePrevious}
      //       className="nav-button-bar position-left"
      //     >
      //       &#8249;
      //     </button>
      //     <LinearProgress
      //       variant="determinate"
      //       value={(progress / 5) * 100}
      //       sx={{
      //         "& .MuiLinearProgress-bar": {
      //           backgroundColor: "white",
      //         },
      //         "& .MuiLinearProgress-root": {
      //           backgroundColor: "gray",
      //         },
      //       }}
      //       className="progress-bar"
      //     />
      //     <button
      //       onClick={handleNext}
      //       className="nav-button-bar position-right"
      //     >
      //       &#8250;
      //     </button>
      //   </div>
      // </div>
      <div className="site-image"
        style={{
          backgroundImage: `url(${c24bg})`,
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundBlendMode: "darken",
        }}>
      <div className="site-details">
           <div className="charge24-logo">
             <img
              src={currentSite.logo}
              alt="site-logo"
              className="logo-image"
            />
          </div>
          <div className="charge24-text">
            <div className="text-site-head">{t(currentSite.title)}</div>
            <div className="sub-site-head">{t(currentSite.description)}</div>
            {currentSite.bullet1 && <li className="sub-site-head">{t(currentSite.bullet1)}</li>}
            {currentSite.bullet2 && <li className="sub-site-head">{t(currentSite.bullet2)}</li>}
            {currentSite.bullet3 && <li className="sub-site-head">{t(currentSite.bullet3)}</li>}
            {currentSite.bullet4 && <li className="sub-site-head">{t(currentSite.bullet4)}</li>}

          </div>
        </div>
      </div>
      )}
      {isMobile && (
        // <div>
        //   <Swiper
        //   spaceBetween={16}
        //   slidesPerView={1}
        //   pagination={{ clickable: true }}
        //   navigation={{
        //     nextEl: null, // ใช้เฉพาะปุ่ม next
        //     prevEl: null, // ไม่ให้มีปุ่ม prev
        //   }}
        //   loop
        // >
        //   {sites.map((slide, index) => (
        //     <SwiperSlide key={index}>
        //       <div
        //         className="mobile-card-main-site"
        //         style={{
        //           backgroundImage: `url(${slide.background})`,
        //           backgroundColor: "rgba(0, 0, 0, 0.8)",
        //           backgroundSize: "cover",
        //           backgroundPosition: "center",
        //           padding: "20px",
        //         }}
        //       >
        //         <div className="mobile-card-main-content-text-head">
        //           {t(slide.title)}
        //         </div>
        //         <div className="mobile-card-main-content-text-sub">
        //         {t(slide.description)}
        //         </div>
        //         {slide.bullet1 && <li className="sub-site-head"> - {t(slide.bullet1)}</li>}
        //         {slide.bullet2 && <li className="sub-site-head"> - {t(slide.bullet2)}</li>}
        //         {slide.bullet3 && <li className="sub-site-head"> - {t(slide.bullet3)}</li>}
        //         {slide.bullet4 && <li className="sub-site-head"> - {t(slide.bullet4)}</li>}
        //         <div className="dots">
        //           {sites.map((_, dotIndex) => (
        //             <span
        //               key={dotIndex}
        //               style={{
        //                 color: dotIndex === index ? "#00ab9d" : "#ccc", // สีเขียวสำหรับจุดปัจจุบัน
        //                 marginRight: "8px",
        //                 fontSize: "48px",
        //               }}
        //             >
        //               .
        //             </span>
        //           ))}
        //         </div>
        //       </div>
        //     </SwiperSlide>
        //   ))}
        // </Swiper>
        // </div>
        <div>
          <div className="mobile-card-main-site"
            style={{
              backgroundImage: `url(${c24bg})`,
              backgroundColor: "rgba(0, 0, 0, 0.7",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundBlendMode: "darken",
              padding: "20px",
            }}>
               <div className="mobile-card-main-content-text-head">
                  {t(currentSite.title)}
               </div>
                <div className="mobile-card-main-content-text-sub">
                {t(currentSite.description)}
                </div>
                {currentSite.bullet1 && <li className="sub-site-head">  {t(currentSite.bullet1)}</li>}
                {currentSite.bullet2 && <li className="sub-site-head">  {t(currentSite.bullet2)}</li>}
                {currentSite.bullet3 && <li className="sub-site-head">  {t(currentSite.bullet3)}</li>}
                {currentSite.bullet4 && <li className="sub-site-head">  {t(currentSite.bullet4)}</li>}
        </div>
        </div>
       
        
      )}
      
    </div>
  );
}

export default Sitereference;
